import ImpactNeurogrowthInfoPage from './components/info/ImpactNeurogrowthInfoPage';

function App() {
  return <ImpactNeurogrowthInfoPage />;
}

export default App;